import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import DownArrowIcon from '../../assets/down-arrow3.svg';
import { extracurricularActivities } from './data';
import styles from './styles.module.scss';

function ExtracurricularActivities() {
	const [index, setIndex] = useState(0);

	const handleSelect = (selectedIndex, e) => {
		setIndex(selectedIndex);
	};

	return (
		<div
			className={`box moreBox ${styles.extracurricularActivities}`}
			id='ExtraCurrBox'
		>
			<h1 className='section-title'>Extracurricular Activities</h1>

			<div className={styles.clubsContainer}>
				<div className={styles.clubsInnerContainer}>
					<Carousel activeIndex={index} onSelect={handleSelect} interval='5000'>
						{extracurricularActivities.map((item) => (
							<Carousel.Item>
								<img
									className={`d-block ${styles.sliderImg}`}
									src={require(`../../assets/ExtracurricularActivities/${item.img}.jpeg`)}
									alt='First slide'
								/>
								<div className={styles.text}>
									<h5>
										{item.job} | {item.title}
									</h5>
									<h6>{item.date}</h6>
									<p>{item.text}</p>
								</div>
							</Carousel.Item>
						))}
					</Carousel>
				</div>
			</div>

			<a href='#certificatesBox'>
				<img src={DownArrowIcon} alt='arrow' className='downArrow'></img>
			</a>
		</div>
	);
}

export default ExtracurricularActivities;
